import customAxios from "config";
import { globalJson } from "global/global_json";
import { renterError } from "utils/errorMessage";

export const AddCustomer = async (payload: any): Promise<any> => {
  try {
    // Make the API call using customAxios
    const response = await customAxios.post<any>(
      "/api/company/add-website-customer/",
      payload
    );
    return { data: response.data };
  } catch (error: any) {
    return { error: renterError(error, "auth") };
  }
};

export const getCustomer = async (email: any): Promise<any> => {
  try {
    const response = await customAxios.get(
      `/api/company/add-website-customer/?email=${email}&company_id=${globalJson.company_id}`
    );
    return response.data;
  } catch (error) {
    console.error("AddCustomer API call failed:", error);
    return;
  }
};

export const getCustomerFiles = async (
  customer_id: number | string,
  related_to: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.get(
      `/api/customers/files/?customer_id=${customer_id}&related_to=${related_to}`
    );
    return { data: response.data };
  } catch (error: any) {
    return { error: renterError(error, "auth") };
  }
};

export const uploadCustomerFiles = async (
  customer_id: number | string,
  files: File[],
  related_to: string,
  onProgress?: (percent: number) => void
): Promise<{ data?: any; error?: string }> => {
  const formData = new FormData();
  formData.append("customer_id", String(customer_id));
  files.forEach((file) => formData.append("files", file));
  formData.append("related_to", related_to);
  try {
    const response = await customAxios.post("/api/customers/files/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        if (!onProgress || !progressEvent.total) return;
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percent);
      },
    });
    return { data: response.data };
  } catch (error: any) {
    return { error: renterError(error, "auth") };
  }
};
